/**
 * 组织管理-查看详情弹框
 */
"use strict";
angular.module("organizationDetailsModule", []).
controller("organizationDetailsCtrl", ["$scope", "$modalInstance", "httpService", "openedData", "modalDialog", function ($scope, $modalInstance, httpService, openedData, modalDialog) {
	initStatus();
	initData();

	function initStatus() {
		$scope.data = {};
	}

	function initData() {
		requestData();
	}

	function requestData() {
		httpService.http('/mcnadmin/admin/group/queryUserById.do', {
			userId: openedData
		}, 'get').then(function (res) {
			if (res.data.groupList != null) {
				var arr = res.data.groupList.split(',');
				var add = [];
				var strArr = [];
				var str = '';
				for (var i = 0; i < arr.length; i++) {
					add.push(arr[i].split('/'));
				}
				for (var k = 0; k < add.length; k++) {
					for(var d=0;d<add[k].length;d++){
						var index=add[k][d].indexOf('#');
						if(d<add[k].length-1) str += add[k][d].slice(index+1)+'>>';
						else str += add[k][d].slice(index+1);
					}
					strArr.push(str);
					str='';
				}
				res.data.groupList=strArr;
				$scope.data = res.data;
			}
		})
	}
	/**
	 * 关闭弹框
	 */
	$scope.cancel = function () {
		$modalInstance.close();
	}
}]);